import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthState } from "../../context/auth";
import NavigatorTabs from "components/Portal/LeftPane/NavigatorTabs";
import { useSinkActions, useSinkState } from "context/sink";
import { css } from "@emotion/core";

export default function ProtectedRoute() {
  const location = useLocation();
  const {
    surveys,
    sink: { folders },
    selectedSurveyId,
  } = useSinkState();
  const { setSelectedSurveyId } = useSinkActions();
  const { isAuthenticated } = useAuthState();

  return isAuthenticated ? (
    <div
      css={css`
        flex-grow: 1;
        flex-direction: column;
        display: flex;
        overflow: hidden;
      `}
    >
      <NavigatorTabs
        surveys={surveys}
        folders={folders}
        selectedSurveyId={selectedSurveyId}
        setSelectedSurveyId={setSelectedSurveyId}
      />
      <Outlet />
    </div>
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}
